import { Card as BaseCard, styled } from "@mui/material";

const Card = styled(BaseCard)((props) => ({
  width: '100%',
  boxShadow: "0px 0px 8px rgba(23, 23, 26, 0.08), 0px 2px 8px rgba(23, 23, 26, 0.05)",
}));

export default Card;
